module.exports = __webpack_public_path__ + "img/nathalie_de_loeper.99a69d54.webp";